<script>
  import Image from '../Attachments/Image.svelte';

  export let post;

  const title = post.settings?.title;
</script>

<div class="col20 f-left circle-post-content image-post-2 flex flex-row align-center">
  <div class="post-text-area ql-container ql-snow">
    {#if title}
      <h1 class="col20 f-left circle-post-content-title">{title}</h1>
    {/if}
    <span class="col20 f-left circle-post-content-paragraph ql-editor">{@html post.content || ''}</span>
  </div>
  {#if post.attachments?.image}
    <Image imageDetails={post.attachments.image} />
  {/if}
</div>
